import { BaseDto } from './base-dto';

export class Tokenjwt extends BaseDto {
    public alg!:string;
    public typ!:string;
    public unique_name!:string;
    public email!:string;
    public nameid!:string;
    public authentication!:string;
    public nbf!:number;
    public exp!:number;
    public iat!:number;
}